window.TV2 = window.TV2 || {};

(function () {
  const STORAGE_KEY = 'tv2_push_subscribed';
  const pushElements = {
    subscribeContainer: null,
    subscribeButtons: null,
  };
  let messaging = null;
  let swRegistration = null;
  let config = null;

  function isSubscribed(topic) {
    const topics = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    return topics && topics.includes(topic);
  }

  function sendInfoPush(title) {
    swRegistration.active.postMessage({
      data: {
        title,
      },
    });
  }

  function updateUI() {
    pushElements.subscribeButtons.forEach((s) => {
      const topic = s.getAttribute('data-topic');
      s.classList.toggle('push-subscribe-button--on', isSubscribed(topic));
    });
  }

  function setSubscribed(topic, subscribe, sendInfo) {
    let topics = JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || [];
    if (subscribe) {
      if (!topics.includes(topic)) {
        topics.push(topic);
      }
      if (sendInfo) {
        sendInfoPush(
          `Du vil få varsel når TV 2 publiserer saker om ${topic}. For å slå av varselet, klikk på knappen nederst i artikkelen.`,
        );
      }
    } else {
      topics = topics.filter((t) => t !== topic);
      if (sendInfo) {
        sendInfoPush(`Du har nå avsluttet varsel om ${topic}.`);
      }
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(topics));
    updateUI();
  }

  function clearSubscriptions() {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
    updateUI();
  }

  function getToken() {
    return messaging
      .getToken({ vapidKey: config.publicVapidKey, serviceWorkerRegistration: swRegistration })
      .catch(() => {
        clearSubscriptions();
      });
  }

  function toggleSubscription(topic) {
    const subscribe = !isSubscribed(topic);

    window.dataLayer.push({
      event: 'interaction',
      eventCategory: 'On-Site Interaction',
      eventAction: `Article - Push ${subscribe ? 'Subscribe' : 'Unsubscribe'}`,
      eventLabel: topic,
    });

    Notification.requestPermission().then(async (permission) => {
      if (permission === 'granted') {
        setSubscribed(topic, subscribe, true);
        const currentToken = await getToken();

        if (currentToken) {
          fetch(
            `${config.apiUrl}/public/subscribe?token=${currentToken}&topic=${topic}&owner=${config.ownerId}`,
            {
              method: subscribe ? 'POST' : 'DELETE',
            },
          ).then((response) => {
            if (response.ok) {
              setSubscribed(topic, subscribe);
            } else {
              setSubscribed(topic, !subscribe);
            }
          });
        } else {
          clearSubscriptions();
        }
      } else {
        // eslint-disable-next-line no-alert
        alert('Du må tillate varsler i nettleseren din for å kunne motta push-varsel fra TV 2.');
      }
    });
  }

  window.TV2.initPush = (configString) => {
    const subscribeContainer = document.querySelector('.push-subscribe');
    const subscribeButtons = subscribeContainer && subscribeContainer.querySelectorAll('button');

    if (subscribeContainer) {
      pushElements.subscribeContainer = subscribeContainer;
      pushElements.subscribeButtons = subscribeButtons;
    }

    config = JSON.parse(configString);
    firebase.initializeApp(config.firebaseConfig);
    messaging = firebase.messaging();

    messaging.onMessage(function (payload) {
      swRegistration.active.postMessage(payload);
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register(`${window.TV2.cdnResources.js}/push.sw.js`)
        .then((registration) => {
          swRegistration = registration;

          if (pushElements.subscribeContainer) {
            updateUI();
            pushElements.subscribeContainer.style.display = null;
          }
        });
    }

    if (pushElements.subscribeButtons) {
      pushElements.subscribeButtons.forEach((s) =>
        s.addEventListener('click', () => toggleSubscription(s.getAttribute('data-topic'))),
      );
    }
  };
})();
